module.exports = __webpack_public_path__ + "static/media/back-arrow-header.4fb67874.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/back-arrow-header.svg
// module id = 299
// module chunks = 0